// WP Block Gallery Slider
ready(function() {
    const body = find("body");
    const galleries = findAll('.wp-block-gallery');
    let mainSplide, thumbnailsSplide;

    galleries.forEach((gallery) => {

        /*
        1. get images
        2. create hidden overlay at the end of the document
        3. create splide html inside the overlay
        4. show overlay for a gallery when clicking on an image in this gallery
        5. init splide sliders (one main slider with prev/next buttons, one navigation slider below with thumbnails
         */

        let galleryId = gallery.getAttribute('class').match(/wp-block-gallery-(\d+)/)[1];
        if (!galleryId) {
            galleryId = Math.floor(Math.random() * 1000000); // generate a random id if not found
        }
        gallery.setAttribute('data-id', galleryId);

        const imageFigures = gallery.findAll('figure.wp-block-image');

        let mainImages = [];
        let thumbnailImages = [];
        imageFigures.forEach((imgFigure) => {
            const img = imgFigure.find('img');
            const src = img.getAttribute('src');
            const srcset = img.getAttribute('srcset');

            // get closest size to 426w
            const thumbnailSrc = srcset.split(',').find((item) => item.includes('426w')).trim().split(' ')[0];
            if (!thumbnailSrc) {
                thumbnailImages.push(src);
            } else {
                thumbnailImages.push(thumbnailSrc);
            }

            // add class "gallery-image"
            imgFigure.classList.add('gallery-image');

            mainImages.push(src);
        });




        let mainSlidesHTML = '';
        mainImages.forEach((image) => {
            mainSlidesHTML += `
                <li class="splide__slide slide">
                    <img data-lazy-src="${image}" alt="Main Image" />
                </li>
            `;
        });
        let thumbnailSlidesHTML = '';
        thumbnailImages.forEach((image) => {
            thumbnailSlidesHTML += `
                <li class="splide__slide slide">
                    <img src="${image}" alt="Thumbnail" />
                </li>
            `;
        });

        let galleryHTML = `
        <div class="gallery-slider">
            <div class="inner">
                <div class="top">
                    <div class="splide main-slider">
                        <div class="splide__track">
                            <ul class="splide__list">
                                ${mainSlidesHTML}
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="splide thumbnail-slider">
                        <div class="splide__track">
                            <ul class="splide__list">
                                ${thumbnailSlidesHTML}
                            </ul>
                        </div>
                    </div>                
                </div>
            </div>
            <a href="#" class="close"><div class="inner"></div></a>
        </div>
        `;

        // append to end of body
        const overlay = document.createElement('div');
        overlay.classList.add('gallery-slider-overlay');
        overlay.setAttribute('data-id', galleryId);
        overlay.innerHTML = galleryHTML;
        document.body.appendChild(overlay);

    });

    on("click", "figure.wp-block-image", (ev) => {
        ev.preventDefault();

        const gallery = ev.target.closest('.wp-block-gallery');
        const galleryId = gallery.getAttribute('data-id');

        let imageIndex = Array.from(gallery.querySelectorAll('figure.wp-block-image')).indexOf(ev.target.closest('figure.wp-block-image'));


        hideAllGalleries(); // hide all galleries first
        body.classList.add("gallery-slider-overlay-open"); // to add overflow: hidden etc.
        showGallery(galleryId); // show the gallery for the clicked image

        function showGallery(id) {
            const galleryOverlay = find(`.gallery-slider-overlay[data-id="${id}"]`);
            if (galleryOverlay) {
                galleryOverlay.classList.add('active');
                activateLazyImages(galleryOverlay);
                initSplide(galleryOverlay);
                gotoSlide(galleryOverlay, imageIndex);
            }
        }

        function hideAllGalleries() {
            const allGalleries = findAll('.gallery-slider-overlay');
            allGalleries.forEach((gallery) => {
                gallery.classList.remove('active');
            });
        }

    });

    function activateLazyImages(galleryOverlay) {
        if (galleryOverlay.dataset.imagesActivated) return;
        galleryOverlay.querySelectorAll('img[data-lazy-src]').forEach((img) => {
            img.setAttribute('src', img.getAttribute('data-lazy-src'));
            img.removeAttribute('data-lazy-src');
        });
        galleryOverlay.dataset.imagesActivated = '1';
    }

    function initSplide(galleryOverlay) {
        const mainSlider = galleryOverlay.find('.main-slider');
        const thumbnailSlider = galleryOverlay.find('.thumbnail-slider');

        if (mainSlider && thumbnailSlider) {
            mainSplide = new Splide(mainSlider, {
                type: 'slide',
                pagination: false,
                arrows: true,
                wheel: true,
            });


            thumbnailsSplide = new Splide(thumbnailSlider, {
                rewind: true,
                fixedWidth: 100,
                fixedHeight: 75,
                gap: 20,
                isNavigation: true,
                focus: 'center',
                pagination: false,
                arrows: false,
                wheel: true,
                cover: true,
                updateOnMove: true,
                padding: {left: 20, right: 20},
            });

            mainSplide.sync(thumbnailsSplide);
            mainSplide.mount();
            thumbnailsSplide.mount();
        }
    }

    function gotoSlide(galleryOverlay, index) {
        const originalMainSpeed = mainSplide.options.speed;
        mainSplide.options.speed = 0;
        const originalThumbnailSpeed = thumbnailsSplide.options.speed;
        thumbnailsSplide.options.speed = 0;

        mainSplide.go(index);
        thumbnailsSplide.go(index);
        mainSplide.options.speed = originalMainSpeed;
        thumbnailsSplide.options.speed = originalThumbnailSpeed;


    }

    // close slider
    on("click", ".gallery-slider-overlay .close", (ev) => {
        ev.preventDefault();
        const galleryOverlay = ev.target.closest('.gallery-slider-overlay');
        if (galleryOverlay) {
            galleryOverlay.classList.remove('active');
            body.classList.remove("gallery-slider-overlay-open");
        }
    });

});